import * as React from 'react';
import { Button } from 'reactstrap';
import { userData } from '../../../util/userData';
import { FontAwesomeIcon } from '../FontAwesomeIcon';

interface IAttritionRiskToggleProps {
  className?: string
  btnColor?: string
  activeBtnColor?: string
  hideCheckbox?: boolean;
}

interface IAttritionRiskToggleState {
  isChecked: boolean
}

export class AttritionRiskToggle extends React.Component<IAttritionRiskToggleProps, IAttritionRiskToggleState> {
  state: IAttritionRiskToggleState = {
    isChecked: false,
  }

  componentWillMount() {
    const filters = userData.getFilters()
    this.state.isChecked = filters.onlyAttritionRisk === true;
  }

  toggleIsChecked(isChecked = !this.state.isChecked) {
    const onlyAttritionRisk = isChecked;

    userData.updateFilters({ onlyAttritionRisk });
    this.setState({ isChecked });
  }

  render() {
    const { className = '', btnColor = 'white', activeBtnColor = btnColor, hideCheckbox = false } = this.props
    const { isChecked } = this.state
    const btnColorProper = isChecked ? activeBtnColor : btnColor;

    return (
      <Button color={btnColorProper} className={className} onClick={() => this.toggleIsChecked()}>
        {!hideCheckbox &&
          <FontAwesomeIcon icon={isChecked ? 'check-square' : 'square'} regular={!isChecked} size="sm" verticalAlign="text-bottom" />
        }
        <span>&nbsp;Attrition Risk</span>
      </Button>
    )
  }
}
